<form (ngSubmit)="fulfil()" [formGroup]="form">
    <div class="modal-header fulfil-parts-modal-header">
        <h5 class="modal-title fulfil-parts-modal-title" translate>job.fulfil.selected.parts</h5>
    </div>
    <div class="tabs-container">
        <div class="selectable-tab" [class.activated]="activeTab === 'requires'" (click)="selectTab('requires')" translate>
            job.requires.fulfilling
            <span class="badge-count">{{completionSummary.notFulfilledPartsCount}}</span>
        </div>

        <div class="selectable-tab" [class.activated]="activeTab === 'ready'" (click)="selectTab('ready')" translate>
            job.ready.to.fulfill
            <span class="badge-count">{{completionSummary.fulfilledPartsCount}}</span>
        </div>
    </div>
    <div class="modal-body fulfil-parts-modal">
            <div *ngIf="!isDataReady" class="loader-container">
                <div class="loading-block">
                    <div class="text-placeholder animated-background w-100 placeholder-input-height"></div>
                </div>

                <div class="loading-block">
                    <div class="text-placeholder animated-background w-30 placeholder-title-height"></div>
                </div>

                <div class="loading-block">
                    <div class="text-placeholder animated-background w-60 placeholder-input-height"></div>
                </div>

                <div class="loading-block part-placeholder" *ngFor="let p of [1,2,3]">
                    <div class="flex-display justify-between">
                        <div class="text-placeholder animated-background w-50 placeholder-title-height"></div>
                        <div class="text-placeholder animated-background w-15 placeholder-title-height"></div>
                    </div>
                    <div class="mt-1 flex-display align-center" *ngFor="let l of [1,2,3]">
                        <div class="text-placeholder animated-background placeholder-checkbox"></div>
                        <div class="text-placeholder animated-background w-40 ml-1 placeholder-title-height"></div>
                        <div class="text-placeholder animated-background w-10 ml-1 placeholder-title-height"></div>
                        <div class="text-placeholder animated-background placeholder-qty-input ml-auto"></div>
                    </div>
                    <div class="text-placeholder animated-background w-100 placeholder-input-height mt-1"></div>
                </div>
            </div>
            <ng-container *ngIf="isDataReady">
            <ng-container *ngIf="activeTab === 'requires'">
                <!-- Engineer Stock Locations -->
                <div class="form-group stock-loc-mb" *ngIf="isStockModule">
                    <label class="cs-d-flex flex-column cs-flex-gap-8px">
                        <span class="control-label" translate>job.stock.available.locations</span>
                        <div class="controls">
                            <input  class="full-width-select2 w-100"
                                    #select2StockLocs
                                    csSelect2
                                    [dropdownvalue]="selectedEngineerStockLocations"
                                    [select2Config]="stockLocationsSelect2Config"/>
                        </div>
                    </label>
                </div>
                <div class="cs-d-flex flex-column cs-flex-gap-16px">
                    <!-- Mass Update -->
                    <div class="form-group p-mass-update cs-d-flex flex-column cs-flex-gap-8px">
                        <span class="control-label" translate>job.mass.update.from</span>
                        <div class="controls">
                            <div #massUpdateContainer class="mass-update-from" [class.open]="massUpdateDropdownOpen">
                                <div class="dropdown-toggle" [class.toggleopen]="massUpdateDropdownOpen" (click)="toggleDropdown()">
                                    <span class="mass-selected-loc" *ngIf="getSelectedLabel()">{{ getSelectedLabel() || '-- Fulfil all parts --' }}</span>
                                    <span *ngIf="!getSelectedLabel()" class="placeholder-color">{{'-- Fulfil all parts --' }}</span>
                                    <span class="arrow"></span>
                                </div>
                                <div class="dropdown-list" *ngIf="massUpdateDropdownOpen">
                                    <div class="search-input-container" *ngIf="isStockModule">
                                        <input type="text" placeholder="Search location" (input)="filterStockRooms($event.target.value)" class="mass-update-search-input" />
                                    </div>
                                    <div class="group scrollable-dropdown" *ngIf="isStockModule">
                                        <label *ngFor="let option of filteredStockRooms; let i = index" class="p-fulfil-checkbox w-100 padding-8px">
                                            <input type="checkbox" [ngModelOptions]="{standalone: true}" [(ngModel)]="option.selected" name="multiOption_{{ i }}" (change)="selectStockLocationFromMassUpdate()" />
                                            {{ option.label }}
                                        </label>
                                    </div>
                                    <hr *ngIf="isStockModule" />
                                    <!-- Fulfil from others -->
                                    <div class="group">
                                        <label *ngFor="let option of fulfilFromOthers" class="p-fulfil-checkbox padding-8px">
                                            <input
                                                type="checkbox"
                                                [checked]="option.selected"
                                                (change)="selectFulfilFromOthers(option)"
                                                name="fulfilFromOther_{{ option.id }}"
                                            />
                                            {{ option.label }}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Part Entries -->
                    <div formArrayName="parts" *ngIf="(completionSummary.totalPartsCount == 0
                                && completionSummary.fulfilledPartsCount == 0
                                && completionSummary.notFulfilledPartsCount == 0 )
                                || completionSummary.totalPartsCount > completionSummary.fulfilledPartsCount">
                        <div *ngFor="let part of parts; let $index = index; trackBy: partTrackBy">
                            <ng-container *ngIf="!part.hidden">
                                <div class="part-item cs-d-flex flex-column cs-flex-gap-16px green-box"
                                     [formGroupName]="String($index)"
                                     [@slideAnimation]
                                     [ngClass]="{
                                        'completed': part.isFulfilled,
                                        'quantity-modified': part.quantityModified,
                                        'cs-flex-gap-6px': !isStockModule,
                                        'cs-flex-gap-16px': isStockModule
                                      }">
                                    <div class="part-title">
                                        <strong>{{ part.name }}</strong>
                                        <i class="fa-solid" [ngClass]="{'fa-circle-check': part.isFulfilled}"></i>
                                        <div class="part-sub">{{ part.code }} <span *ngIf="part.code">.</span> <strong>Qty: {{ part.totalQuantity }}</strong></div>
                                    </div>
                                    <div class="fulfil-options" formArrayName="availableParts" *ngIf="!part.outOfStock">
                                            <ng-container *ngFor="let loc of getLocations($index); let j = index; trackBy: locationTrackBy">
                                            <div class="option-row" [formGroupName]="j" *ngIf="loc.get('view')?.value === true && loc.get('location')?.value != 'General'">
                                                <label class="p-fulfil-checkbox cs-flex-gap-4px">
                                                    <input type="checkbox" formControlName="selected" name="loc_{{ partsFormArray[$index].get('code').value }}_{{ loc.get('id').value }}"
                                                           [disabled]="loc.disabled"/> <span class="custom-checkbox" [ngClass]="{'checked': loc.get('selected').value,'disabled': loc.disabled}"></span> {{ loc.get('location').value }}
                                                    <span class="stock-count">({{ loc.get('quantity').value }})</span>
                                                    <span *ngIf="loc.get('quantityInDue')?.value" class="sub-label" translate>({{ loc.get('quantityInDue').value }} due in)</span>
                                                </label>
                                                <input type="number"
                                                       class="qty-input" [disabled]="!loc.get('selected').value || loc.disabled" formControlName="allocation" name="qty_{{ partsFormArray[$index].get('code').value }}_{{ loc.get('id').value }}" placeholder="Qty" min="0" step="0.01"
                                                />
                                            </div>
                                        </ng-container>
                                    </div>

                                    <div class="out-of-stock" *ngIf="part.outOfStock && isStockModule">
                                        <span translate><i class="fa-solid fa-triangle-exclamation"></i> job.not.in.stock</span>
                                    </div>
                                    <div class="fulfil-options">
                                        <div class="fulfil-from-other-row">
                                            <select class="form-control select2-fulfil"
                                                    [formControlName]="'selectFulfilFromOther'"
                                                    [attr.id]="'fulfil-from-other-' + $index"
                                                    csSelect2
                                                    [select2Config]="{
                                                        width: '100%',
                                                        minimumResultsForSearch: Infinity,
                                                        placeholder: '-- Select fulfil option --',
                                                        allowClear: true,
                                                        templateResult: getOptionTemplate($index),
                                                        templateSelection: getOptionTemplate($index)
                                                    }"
                                                    (ngModelChange)="selectManualFulfilFromOthers($event,partsFormArray[$index])"
                                            >
                                                <option value="">-- Please select --</option>
                                                <option *ngFor="let option of fulfilFromOthers" [value]="option.id">
                                                    {{option.label}} ({{getRemainingQty(partsFormArray[$index])}})</option>
                                            </select>

                                                </div>
                                            </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <ng-container *ngTemplateOutlet="completionSummary.totalPartsCount === completionSummary.fulfilledPartsCount ? completedGreeting : null"></ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="activeTab === 'ready'">
                <ng-container *ngTemplateOutlet="completedParts"></ng-container>
            </ng-container>
            </ng-container>
    </div>

    <div class="modal-footer">
        <button class="btn" type="button" (click)="onCloseModal()" translate>Cancel</button>
        <button #saveBtn class="btn btn-primary" [disabled]="(completionSummary.totalPartsCount !== completionSummary.fulfilledPartsCount && isDataReady) || action == 'fulfilling'">
            <span [hidden]="action == 'fulfilling'" translate>job.fulfill</span>
            <span [hidden]="action != 'fulfilling'" translate>job.fulfilling</span>
        </button>
    </div>
</form>

<ng-template #completedParts>
    <ng-container *ngIf="completionSummary.fulfilledPartsCount === 0">
        <div class="empty-ready-to-fulfil">
            <div class="empty-icon">
                <i class="fa-solid fa-wrench"></i>
            </div>
            <div class="empty-title" translate>job.no.parts.to.fulfill</div>
            <div class="empty-desc" translate>job.no.parts.to.fulfill.description</div>
        </div>
    </ng-container>
    <div *ngFor="let part of parts; let $index = index;">
        <ng-container *ngIf="part.isFulfilled">
            <div class="part-item cs-d-flex flex-column green-box completed" [ngClass]="!isStockModule ? 'cs-flex-gap-6px' : 'cs-flex-gap-16px'">
                <div class="part-title">
                    <strong>{{ part.name }}</strong>
                    <i class="fa-solid fa-circle-check"></i>
                    <div class="part-sub">{{part.code}} <span *ngIf="part.code">.</span> <strong>Qty: {{part.totalQuantity}}</strong></div>
                </div>
                <div class="fulfil-options">
                    <ng-container *ngFor="let location of part.availableParts">
                        <ng-container *ngIf="location.view">
                            <div class="option-row">
                                <label class="p-fulfil-checkbox cs-flex-gap-4px disabled">
                                    <input type="checkbox" [disabled]="true" [(ngModel)]="location.selected" class="alwaysChecked"/>
                                    <span class="custom-checkbox checked disabled"></span>
                                    <span class="stock-count">{{location.location}}</span>
                                    <span class="stock-count">({{location.quantity}})</span>
                                    <span *ngIf="location.quantityInDue>0" class="sub-label" translate>({{ location.quantityInDue }} due in)</span>
                                </label>
                                <input type="number" class="qty-input" [disabled]="true" [ngModel]="location.allocation === 0 ? '' : location.allocation" placeholder="Qty" min="0" step="0.01"/>
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="part.outOfStock && isStockModule">
                        <div class="out-of-stock">
                            <span translate><i class="fa-solid fa-triangle-exclamation"></i> job.not.in.stock</span>
                        </div>
                    </ng-container>
                </div>
                <div class="fulfil-options">
                    <div class="fulfil-from-other-row">
                        <select class="form-control select2-fulfil disabled"
                                [disabled]="true"
                                csSelect2
                                [select2Config]="{
                                                width: '100%'
                                            }"
                                [dropdownvalue]="part.selectFulfilFromOther"
                                [(ngModel)]="part.selectFulfilFromOther"
                        >
                            <option value="">-- Please select --</option>
                            <option *ngFor="let option of fulfilFromOthers" [value]="option.id">
                                {{option.label}} ({{part.selectFulfilFromOtherQty}})</option>
                        </select>

                    </div>
                </div>
                <a href="javascript:void(0);" class="move-back-to-requires-fulfilling" (click)="resetPartFulfillment($index, part)" translate>job.move.back.to.fulfilling</a>
            </div>
        </ng-container>
    </div>
</ng-template>

<ng-template #completedGreeting>
    <div *ngIf="completionSummary.totalPartsCount > 0" class="greeting-wrapper">
        <div class="visual">
            <i class="fa-solid fa-circle-check"></i>
            <div class="content-label">
                <span class="label-congrats" translate>job.success.all.parts.ready.to.fulfil.title</span>
                <span class="label-congrats-desc" translate>job.success.all.parts.ready.to.fulfil.subtitle</span>
                <span class="info-label" translate>job.success.all.parts.ready.to.fulfil.description</span>
            </div>
        </div>
        <div class="summary-content">
            <span class="summary-header" translate>job.summary.of.parts</span>
            <div class="part-content">
                <ng-container *ngFor="let locationTotal of completionSummary.stockLocationTotals;">
                    <span *ngIf="locationTotal?.id || locationTotal?.location === 'General'" class="detailed-label">
                        <i class="fa-solid fa-check summary-bold"></i>
                        <span class="summary-bold">{{locationTotal?.totalQty}}</span>
                        <span class="from-label" translate>from {{locationTotal?.location}}</span>
                    </span>
                </ng-container>
                <ng-container *ngFor="let others of completionSummary.otherSourceTotals | keyvalue;">
                    <ng-container *ngIf="others.value > 0 && others.key !== 'job.general'">
                        <span class="detailed-label">
                            <i class="fa-solid fa-check summary-bold"></i>
                            <span class="summary-bold">{{ others.value }}</span>
                            <span class="from-label" translate>{{ others.key }}</span>
                        </span>
                    </ng-container>
                </ng-container>
            </div>
        </div>
    </div>
</ng-template>

